import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  CustomSnackbarComponent,
  CustomSnackbarData,
} from '../components/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class CustomSnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string, title?: string, duration?: number): void {
    this.showSnackbar({
      message,
      title: title || 'Success',
      type: 'success',
      duration: duration || 5000,
    });
  }

  showError(message: string, title?: string, duration?: number): void {
    this.showSnackbar({
      message,
      title: title || 'Error',
      type: 'error',
      duration: duration || 5000,
    });
  }

  showErrorKey(
    translationKey: string,
    titleKey?: string,
    duration?: number
  ): void {
    this.showSnackbar({
      translationKey,
      title: titleKey,
      type: 'error',
      duration: duration || 5000,
    });
  }

  showErrorWithRetry(
    message: string,
    onRetry: () => void,
    title?: string,
    duration?: number
  ): void {
    this.showSnackbar({
      message,
      title: title || 'Error',
      type: 'error',
      duration: duration || 5000,
      onRetry,
    });
  }

  showErrorWithRetryKey(
    translationKey: string,
    onRetry: () => void,
    titleKey?: string,
    duration?: number
  ): void {
    this.showSnackbar({
      translationKey,
      title: titleKey,
      type: 'error',
      duration: duration || 5000,
      onRetry,
    });
  }

  showWarning(message: string, title?: string, duration?: number): void {
    this.showSnackbar({
      message,
      title: title || 'Warning',
      type: 'warning',
      duration: duration || 5000,
    });
  }

  showInfo(message: string, title?: string, duration?: number): void {
    this.showSnackbar({
      message,
      title: title || 'Info',
      type: 'info',
      duration: duration || 5000,
    });
  }

  private showSnackbar(data: CustomSnackbarData): void {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data,
      duration: data.duration || 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['full-width-snackbar', 'custom-full-width'],
    });
  }

  // Method to close all snackbars
  dismissAll(): void {
    this.snackBar.dismiss();
  }
}
